import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gutter-repair")({
  beforeLoad: () => {
    throw redirect({ to: "/services/gutter-repairs", statusCode: 301 });
  },
});
